import axios from "axios";
import { AddressResolution } from "utils/addressParts";

/** Reverse lookup only after an explicit click; no logs or raw errors. */
export async function geolocateAddress(lat: number, lng: number, key: string): Promise<string | null> {
  return (await geolocateAddressDetails(lat, lng, key))?.text || null;
}

export async function geolocateAddressDetails(lat: number, lng: number, key: string): Promise<AddressResolution | null> {
  if (!key || !Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  try {
    const { data } = await axios.get("https://maps.googleapis.com/maps/api/geocode/json", {
      params: { latlng: `${lat},${lng}`, key }, timeout: 10000,
    });
    const result = data?.results?.[0];
    const address = result?.formatted_address;
    return typeof address === "string" && address.trim() && address.trim().toLowerCase() !== "not found"
      ? { text: address.trim(), components: result?.address_components, location: { lat, lng }, placeId: typeof result?.place_id === "string" ? result.place_id : undefined }
      : null;
  } catch { return null; }
}
